import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TUpdateCompanyInfoRequest,
  TUpdateCompanyInfoResponse,
} from "./updateCompanyInfo.schema";

export const updateCompanyInfo = (axios: IAxiosInstance) => {
  return async (data: TUpdateCompanyInfoRequest) => {
    const response = await axios.noRetry.patch<
      IApiResponse<TUpdateCompanyInfoResponse>
    >(`/api/updateCompany`, data);

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
